<template>
  <div class="page-nav">
    <div
      v-for="item in items"
      :key="item.key"
      class="page-nav__item"
      :class="item.key === value ? 'active' : ''"
      @click="$emit('input', item.key)"
    >{{item.label}}</div>
  </div>
</template>

<script>
export default {
  name: 'AppNav',
  props: {
    items: {
      type: Array,
      default() {
        return []
      }
    },
    value: {
      type: [String, Number],
      default: ''
    }
  }
}
</script>
